import { jsonp } from 'ThreeTerminal_base/base';

// 疫情地方内容
export const getAreaContent = async (prov, id) => {
    const data = await jsonp(`https://shankapi.ifeng.com/c/api/getAreaContent/${id}/20/${prov}`, {
        jsonpCallback: prov,
        cache: false,
    });

    if (data.code === 0 && data.data && data.data.length > 0) {
        return data.data;
    }

    return [];
};
